import { render } from "./MainBranchList.vue?vue&type=template&id=5ffa6a3a&scoped=true"
import script from "./MainBranchList.vue?vue&type=script&lang=js"
export * from "./MainBranchList.vue?vue&type=script&lang=js"

import "./MainBranchList.vue?vue&type=style&index=0&id=5ffa6a3a&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa6a3a"]])

export default __exports__